function returnUtmString(){
    const regex = /([?&])(utm_(source|medium|campaign|term|content)|gclid)=([^&]+)/g; // For UTM and GCLID
    
    let match;
    let matches = []
    while((match) = regex.exec(window.location.search)){
        matches.push(match[4]); // IF UTM AND GCLID
    }
    console.log(matches.join('-'))
    return matches.join('-');
}

window.addEventListener('load',()=>{
const form = document.querySelector('.pxFormGenerator iframe');
if(form && window.location.search.includes('utm')){
  setTimeout(()=>{
    form.contentWindow.postMessage({utmParams: returnUtmString()},'*')
  },2000)
}
})
